import React from 'react';
import { connect } from 'react-redux';

import DashboardCustomer from 'components/layout/dashboard/DashboardCustomer';
import DashboardEmployee from 'components/layout/dashboard/DashboardEmployee';
import DashboardVendor from 'components/layout/dashboard/DashboardVendor';

import { ROLE_ROOT_EMPLOYEE, ROLE_VENDOR } from 'js/constants';
import may from 'js/security';

// this component serves as dashboard
class AccountIndex extends React.Component {
  render() {
    const {
      user: { roles },
    } = this.props;

    const Dashboard = may(ROLE_ROOT_EMPLOYEE, roles)
      ? DashboardEmployee
      : may(ROLE_VENDOR, roles)
      ? DashboardVendor
      : DashboardCustomer;

    return <Dashboard />;
  }
}

const mapStateToProps = state => {
  return {
    user: state.login.user,
  };
};

export default connect(mapStateToProps)(AccountIndex);
